/**
 * Yemek Karti kanali secildiginde urun tabanli bloklarin bos durumu (spec §3). Yemek karti satisi ERP'ye
 * urun kirilimi olmadan tek toplu kalem ("TÜKETİME HAZIR GIDA") olarak giriliyor (spec §2.1).
 * Bos kutu yerine NEDEN yazilir: aksi halde ekran "bozuk" okunur.
 */
export function UrunKirilimiYok() {
  return (
    <p data-testid="urun-kirilimi-yok" className="text-[12px] text-ink-500">
      Bu kanal ürün kırılımı taşımıyor — yemek kartı satışı tek toplu kalem olarak giriliyor.
    </p>
  );
}
